(() => {
  const initTabs = (root) => {
    const tabsRoot = root.matches?.('[data-vf-product-tabs]')
      ? root
      : root.querySelector?.('[data-vf-product-tabs]');
    if (!tabsRoot || tabsRoot.dataset.vfTabsInitialized === 'true') return;

    tabsRoot.dataset.vfTabsInitialized = 'true';
    const getTabs = () => Array.from(tabsRoot.querySelectorAll('[data-vf-tab]'));
    const getPanels = () => Array.from(tabsRoot.querySelectorAll('[data-vf-panel]'));

    const activate = (name, focus = false) => {
      const tabs = getTabs();
      const panels = getPanels();

      tabs.forEach((tab) => {
        const active = tab.dataset.vfTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && focus) tab.focus();
      });

      panels.forEach((panel) => {
        const active = panel.dataset.vfPanel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    getTabs().forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.vfTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = getTabs();
        const index = tabs.indexOf(tab);
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activate(tabs[next].dataset.vfTab, true);
      });
    });

    const isThemeEditor = typeof Shopify !== 'undefined' && Shopify.designMode === true;
    const lowerGrid = tabsRoot.closest('[data-vf-product-lower-grid]');
    const relatedTarget = lowerGrid?.querySelector('[data-vf-related-target]');
    const relatedSource = document.querySelector('[data-vf-related-source]');

    if (!isThemeEditor && relatedTarget && relatedSource && !relatedTarget.contains(relatedSource)) {
      relatedTarget.appendChild(relatedSource);
      relatedSource.hidden = false;
      relatedSource.classList.add('vf-related-section--in-grid');
    } else if (!relatedSource) {
      lowerGrid?.querySelector('.vf-often-bought')?.remove();
    }

    const reviewTarget = tabsRoot.querySelector('[data-vf-review-target]');
    const reviewSectionKey = tabsRoot.dataset.reviewSectionKey;
    const reviewSection = reviewSectionKey
      ? document.querySelector('[id*="' + reviewSectionKey + '"]')
      : null;

    if (!isThemeEditor && reviewTarget && reviewSection && !reviewTarget.contains(reviewSection)) {
      reviewTarget.appendChild(reviewSection);
      reviewSection.classList.add('vf-review-section--in-tab');
    } else if (!reviewSection) {
      tabsRoot.querySelector('[data-vf-tab="reviews"]')?.remove();
      tabsRoot.querySelector('[data-vf-panel="reviews"]')?.remove();
    }

    const description = tabsRoot.querySelector('[data-vf-description]');
    const copy = tabsRoot.querySelector('[data-vf-description-copy]');
    const toggle = tabsRoot.querySelector('[data-vf-description-toggle]');

    if (description && copy && toggle) {
      requestAnimationFrame(() => {
        const needsToggle = copy.scrollHeight > 240;
        if (needsToggle) {
          description.classList.add('is-collapsed');
          toggle.hidden = false;
          toggle.textContent = toggle.dataset.more || 'Read more';
        }
      });

      toggle.addEventListener('click', () => {
        const collapsed = description.classList.toggle('is-collapsed');
        toggle.textContent = collapsed
          ? (toggle.dataset.more || 'Read more')
          : (toggle.dataset.less || 'Show less');
      });
    }

    activate(getTabs()[0]?.dataset.vfTab || 'description');
  };

  const initSummaryLinks = () => {
    document.querySelectorAll('[data-vf-summary-more]').forEach((button) => {
      if (button.dataset.vfSummaryInitialized === 'true') return;
      button.dataset.vfSummaryInitialized = 'true';

      button.addEventListener('click', () => {
        const tabsRoot = document.querySelector('[data-vf-product-tabs]');
        const descriptionTab = tabsRoot?.querySelector('[data-vf-tab="description"]');
        const descriptionPanel = tabsRoot?.querySelector('[data-vf-panel="description"]');

        if (descriptionTab) descriptionTab.click();
        (tabsRoot || descriptionPanel)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-vf-product-tabs]').forEach((root) => initTabs(root));
    initSummaryLinks();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTabs(event.target);
    initSummaryLinks();
  });
})();